import React from 'react';
import { i18n as I18NextInstance } from 'i18next';

import { createI18N } from '../createI18N';

export const I18NContext = React.createContext(createI18N());

export function I18NProvider({
  i18n,
  children,
}: {
  i18n: I18NextInstance;
  children: React.ReactNode;
}): React.ReactElement {
  return <I18NContext.Provider value={i18n}>{children}</I18NContext.Provider>;
}
